import React, { useEffect } from 'react';

import { endpoints } from 'constants/endpoints';

export default function EmbeddedAnalyticsIframe() {
  useEffect(() => {
    fetch(endpoints.embeddedAnalytics.connect, { credentials: 'include' })
      .then((res) => res.json())
      .then((res) => {
        (document.getElementById('samlresponse') as HTMLInputElement).value = res?.entity?.SAMLResponse;
        (document.getElementById('relaystate') as HTMLInputElement).value = res?.entity?.RelayState;
        setTimeout(() => {
          document.forms[0].submit();
        }, 0);
      })
      .catch((err) => {
        console.error('Failed to connect', err);
      });
  }, []);

  return (
    <div>
      <form method="post" name="hiddenform" action="https://mesh.visier.com/VServer/auth/authenticateWithSaml">
        <input type="hidden" name="SAMLResponse" id="samlresponse" />
        <input type="hidden" name="RelayState" id="relaystate" />
        <noscript>
          <input type="submit" value="Submit" />
        </noscript>
      </form>
    </div>
  );
}
